import {
    FETCH_DATA_FOR_RECOMMENDATION,
    FETCH_DATA_SAVE_FOR_LATER,
    RESET_PRODUCT_CARTRIDGE_REDUCER,
    CERTONA_OPTIONS,
    REMOVE_PRODUCT_CARTRIDGE_SLOT,
    ENSIGHTEN_ERROR_EVENT,
    ADD_PRODUCT_CARTRIDGE_SLOT,
} from '../actionTypes/ProductCartridgeActionTypes';
import { recommendationSourceType } from '../common/Constants';

const getProductListForCartridgeSlot = (props) => {
    const {
        pageType,
        deviceType,
        slotId,
        loader,
        attributes,
        host,
        regionZone,
        certonaUrl,
        forceRefresh,
        itemId,
        limit,
        refreshCertona,
        style,
        adobeScheme,
        isLoggedIn,
    } = props;
    const payload = {
        pageType,
        deviceType,
        slotId,
        loader,
        attributes,
        host,
        regionZone,
        certonaUrl,
        forceRefresh,
        itemId,
        limit,
        refreshCertona,
        style,
        adobeScheme,
        isLoggedIn,
    };

    let invokeLoader = loader;

    // Each loader should have unique constant name to trigger respective watcher saga
    switch (loader) {
        case recommendationSourceType.Adobe:
        case recommendationSourceType.Certona:
            invokeLoader = FETCH_DATA_FOR_RECOMMENDATION;
            break;
        case recommendationSourceType.GetAllSaveForLater:
            invokeLoader = FETCH_DATA_SAVE_FOR_LATER;
            break;
        default:
            break;
    }

    return {
        type: invokeLoader,
        payload,
    };
};

/* istanbul ignore next */
const resetProductCartridgeStore = () => ({
    type: RESET_PRODUCT_CARTRIDGE_REDUCER,
});

/* istanbul ignore next */
const addCertonaOptions = (payload) => ({
    type: CERTONA_OPTIONS,
    payload,
});

/* istanbul ignore next */
const removeProductCartridgeSlot = (schemaName) => ({
    type: REMOVE_PRODUCT_CARTRIDGE_SLOT,
    schemaName,
});

const addProductCartridgeSlot = (slotData) => ({
    type: ADD_PRODUCT_CARTRIDGE_SLOT,
    slotData,
});

/* istanbul ignore next */
const triggerEnsightenEvent = (payload) => ({
    type: ENSIGHTEN_ERROR_EVENT,
    payload,
});

export default {
    getProductListForCartridgeSlot,
    removeProductCartridgeSlot,
    resetProductCartridgeStore,
    addCertonaOptions,
    triggerEnsightenEvent,
    addProductCartridgeSlot,
};
